export const SHOOT_TYPES = {
  PRIVATE: 'private',
  COMMERCIAL: 'commercial',
  PRODUCTION: 'production',
};

export const DEFAULT_PHOTOSHOOT_PRICING = {
  // Revised tariffs are final, all-inclusive prices.
  private_3: { price: 7200, limit: 10, deposit: 0 },
  private_6: { price: 12600, limit: 15, deposit: 0 },
  commercial_6: { price: 24000, limit: 20, deposit: 0 },
  commercial_12: { price: 40000, limit: 25, deposit: 0 },
  production_6: { price: 35000, limit: 20, deposit: 0 },
  production_12: { price: 55000, limit: 35, deposit: 0 },
};

export function getPhotoshootPricing({ duration, shootType, headcount, config = DEFAULT_PHOTOSHOOT_PRICING }) {
  const rules = { ...DEFAULT_PHOTOSHOOT_PRICING, ...(config || {}) };
  const hours = Number(duration);
  const people = Number(headcount);

  if (!Number.isInteger(people) || people < 1) {
    return { valid: false, reason: 'Enter the total number of people attending the shoot.' };
  }
  if (![3, 6, 12].includes(hours)) {
    return { valid: false, reason: 'Select a 3, 6, or 12 hour photoshoot session.' };
  }
  if (shootType === SHOOT_TYPES.PRIVATE) {
    if (hours === 12) return { valid: false, reason: '12-hour sessions are available for Product / Commercial and Movie / OTT shoots.' };
    const rule = rules[`private_${hours}`];
    const limit = rule.limit;
    if (people > limit) {
      return { valid: false, reason: `Private ${hours}-hour shoots are limited to ${limit} people. Please contact us for a custom quote.` };
    }
    return { valid: true, price: Number(rule.price), deposit: 0 };
  }

  if (shootType === SHOOT_TYPES.COMMERCIAL) {
    if (hours === 3) return { valid: false, reason: '3-hour sessions are only for couple and family photoshoots. Commercial shoots require a 6- or 12-hour session.' };
    const standard = rules[`commercial_${hours}`];
    if (people > standard.limit) return { valid: false, reason: `Commercial ${hours}-hour shoots above ${standard.limit} people require a custom quote.` };
    return { valid: true, price: Number(standard.price), deposit: 0 };
  }

  if (shootType === SHOOT_TYPES.PRODUCTION) {
    if (hours === 3) return { valid: false, reason: '3-hour sessions are only for couple and family photoshoots. Movie / OTT shoots require a 6- or 12-hour session.' };
    const rule = rules[`production_${hours}`];
    if (people > rule.limit) return { valid: false, reason: `Movie / OTT / production ${hours}-hour shoots above ${rule.limit} people require a custom quote.` };
    return { valid: true, price: Number(rule.price), deposit: 0 };
  }

  return { valid: false, reason: 'Select the type of shoot.' };
}
